import React, { useState, useEffect } from "react";
import styles from "./comments.module.css";
import Rating from "../../componnents/Ratings/Ratings";
import axios from "axios";
import { Skeleton, Empty } from "antd";
import { separateByThreeDigits } from "../../componnents/helper/global";

// هر صفحه ۲۰۰ نظر. اگر API کلید pagination بدهد از سرور صفحه‌بندی می‌کنیم؛
// وگرنه (API قدیمی که همه‌ی نظرات را یکجا می‌دهد) خودمان سمت کلاینت برش می‌زنیم.
const PER_PAGE = 200;

const Comments = (props) => {
  const dr_id = props.match.params.d_id;

  const [loading, setLoading] = useState(false);
  const [reviewsLoading, setReviewsLoading] = useState(false);

  const [commentLists, setCommentList] = useState([]);
  // وقتی API صفحه‌بندی ندارد، کل لیست اینجا می‌ماند و نمایش را از رویش برش می‌زنیم
  const [allComments, setAllComments] = useState([]);
  const [serverPaging, setServerPaging] = useState(false);

  const [reviews, setReviews] = useState(null);

  const [total, setTotal] = useState(null);
  const [score, setScore] = useState(null);

  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    getDrComments();
  }, []);

  const fetchCommentsPage = async (targetPage) => {
    const randomSixDigits = Math.floor(100000 + Math.random() * 900000);

    const config = {
      method: "get",
      url: `${
        window.server
      }/doctor/comments/all/${dr_id}/${targetPage}?per_page=${PER_PAGE}&_${randomSixDigits}`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await axios(config);

    return response.data;
  };

  const getDrComments = async () => {
    setLoading(true);

    try {
      const data = await fetchCommentsPage(0);
      const comments = data.comments || [];

      setReviews(data.reviews || null);
      setPage(0);

      if (data.pagination) {
        setServerPaging(true);
        setAllComments([]);
        setCommentList(comments);
        setHasMore(!!data.pagination.has_more);
      } else {
        // API قدیمی: کل نظرات یکجا → فقط ۲۰۰تای اول را نشان بده
        setServerPaging(false);
        setAllComments(comments);
        setCommentList(comments.slice(0, PER_PAGE));
        setHasMore(comments.length > PER_PAGE);
      }

      if (data.reviews && data.reviews.total > 1000) {
        getReviews({ niceId: data.nice_id });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const loadMoreAction = async () => {
    if (loadingMore || !hasMore) return;

    setLoadingMore(true);

    const nextPage = page + 1;

    try {
      if (serverPaging) {
        const data = await fetchCommentsPage(nextPage);

        setCommentList((prev) => prev.concat(data.comments || []));
        setHasMore(data.pagination ? !!data.pagination.has_more : false);
        setPage(nextPage);
      } else {
        const visible = allComments.slice(0, (nextPage + 1) * PER_PAGE);

        setCommentList(visible);
        setHasMore(visible.length < allComments.length);
        setPage(nextPage);
      }
    } catch (error) {
    } finally {
      setLoadingMore(false);
    }
  };

  // only for doctors with more than 1000 comments
  const getReviews = async ({ niceId }) => {
    setReviewsLoading(true);

    const config = {
      method: "get",
      url: `${window.server}/doctor/${niceId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios(config);

      setTotal(response.data[0]["o"]["star"]["count"]);
      setScore(response.data[0]["o"]["star"]["rate"]);
    } catch (error) {
    } finally {
      setReviewsLoading(false);
    }
  };

  // تعداد واقعیِ نظرات؛ برای پزشکانِ پرنظر عددِ درست از getReviews می‌آید،
  // چون reviews.total به سقفِ ۱۵۰۰ محدود است.
  const commentsCount = total || (reviews && reviews.total) || 0;

  const closeAction = () => {
    window.opener = null;
    window.open("", "_self");
    window.close();
  };

  const commentView = (val, index) => {
    return (
      <div className={styles.comment_box} key={val.id || index}>
        <div className={styles.comment_box_right}>
          <div className={styles.rating_container}>
            <Rating rating={val.rate} />
          </div>

          <span
            className={[
              styles.comment_text,
              val.show ? "" : styles.hidden,
            ].join(" ")}
          >
            {val.text}
          </span>
        </div>

        <small className={styles.comment_date}>{val.date}</small>
      </div>
    );
  };

  return (
    <div className={styles.main}>
      <button className={styles.back_btn} onClick={() => closeAction()}>
        بازگشت
      </button>

      <span className={styles.title}>لیست نظرات</span>

      <div className={styles.sub_title}>
        <p>
          در نوبت دات آی آر، هر بیمار فقط <b>یک‌ بار</b> می‌تواند درباره هر پزشک
          نظر ثبت کند.
        </p>

        <p>آخرین نظر هر کاربر از روند درمان نمایش داده می‌شود.</p>

        {commentsCount > 100 && (
          <p data-role="trust-note">
            ✅ به همین دلیل، نظراتی که می‌خوانید <b>بدون تکرار و قابل اعتماد</b>{" "}
            هستند.
          </p>
        )}
      </div>

      {loading ? (
        <Skeleton active />
      ) : (
        <>
          {reviews && !reviewsLoading && (
            <div className={styles.reviews}>
              <div className={styles.reviews_summary}>
                <div>
                  <span>{score || reviews.score}</span>
                  <span data-role="max-score">/5</span>
                </div>

                <p className={styles.reviews_summary_count}>
                  ({separateByThreeDigits(total || reviews.total)} نظر)
                </p>
              </div>

              <div className={styles.reviews_chart}>
                <div className={styles.reviews_chart_lines}>
                  <div data-role="line">
                    <div
                      data-role="filled"
                      style={{
                        width: `${(reviews.great * 100) / reviews.total}%`,
                      }}
                    />
                  </div>

                  <div data-role="line">
                    <div
                      data-role="filled"
                      style={{
                        width: `${(reviews.average * 100) / reviews.total}%`,
                      }}
                    />
                  </div>

                  <div data-role="line">
                    <div
                      data-role="filled"
                      style={{
                        width: `${(reviews.bad * 100) / reviews.total}%`,
                      }}
                    />
                  </div>
                </div>

                <div className={styles.reviews_chart_titles}>
                  <span>عالی</span>
                  <span>متوسط</span>
                  <span>ضعیف</span>
                </div>
              </div>
            </div>
          )}

          <div style={{ display: "grid", gap: "0.75rem" }}>
            {commentLists.length > 0 ? (
              commentLists.map(commentView)
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={<span>اطلاعاتی برای نمایش وجود ندارد</span>}
              />
            )}
          </div>

          {hasMore && (
            <button
              className={styles.more_btn}
              onClick={() => loadMoreAction()}
              disabled={loadingMore}
            >
              {loadingMore ? "در حال بارگذاری ..." : "نمایش نظرات بیشتر"}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default Comments;
